import { render } from "./VNavigationButton.vue?vue&type=template&id=648c8590&scoped=true"
import script from "./VNavigationButton.vue?vue&type=script&lang=js"
export * from "./VNavigationButton.vue?vue&type=script&lang=js"

import "./VNavigationButton.vue?vue&type=style&index=0&id=648c8590&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648c8590"]])

export default __exports__